import type { SVGProps } from "react";
import React from "react";

export const BinIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = "12",
  height = "15",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 15"
    fill={fill}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.27515 0.951437C4.34957 0.877073 4.4505 0.835296 4.55575 0.835296H7.44464C7.54988 0.835296 7.65082 0.877073 7.72524 0.951437C7.79966 1.0258 7.84146 1.12666 7.84146 1.23183V2.08833H4.15892V1.23183C4.15892 1.12666 4.20073 1.0258 4.27515 0.951437ZM4.55575 0.0422363C4.24002 0.0422363 3.93721 0.167567 3.71396 0.390659C3.4907 0.613751 3.36527 0.916328 3.36527 1.23183V2.09619H1.23813H0.396825C0.177665 2.09619 0 2.27372 0 2.49272C0 2.71172 0.177665 2.88925 0.396825 2.88925H0.841309V13.0483C0.841309 13.3638 0.966733 13.6664 1.18999 13.8895C1.41325 14.1126 1.71605 14.2379 2.03179 14.2379H9.96829C10.284 14.2379 10.5868 14.1126 10.8101 13.8895C11.0333 13.6664 11.1588 13.3638 11.1588 13.0483V2.88925H11.6032C11.8223 2.88925 12 2.71172 12 2.49272C12 2.27372 11.8223 2.09619 11.6032 2.09619H10.7619H8.63511V1.23183C8.63511 0.916328 8.50969 0.613751 8.28643 0.390659C8.06318 0.167567 7.76037 0.0422363 7.44464 0.0422363H4.55575ZM1.63496 2.88925H10.3651V13.0483C10.3651 13.1535 10.3233 13.2544 10.2489 13.3287C10.1745 13.4031 10.0735 13.4449 9.96829 13.4449H2.03179C1.92654 13.4449 1.82561 13.4031 1.75119 13.3287C1.67677 13.2544 1.63496 13.1535 1.63496 13.0483V2.88925ZM4.5875 4.38867C4.80666 4.38867 4.98432 4.5662 4.98432 4.7852V11.5103C4.98432 11.7293 4.80666 11.9069 4.5875 11.9069C4.36834 11.9069 4.19067 11.7293 4.19067 11.5103V4.7852C4.19067 4.5662 4.36834 4.38867 4.5875 4.38867ZM7.41269 4.38867C7.63186 4.38867 7.80952 4.5662 7.80952 4.7852V11.5103C7.80952 11.7293 7.63186 11.9069 7.41269 11.9069C7.19353 11.9069 7.01587 11.7293 7.01587 11.5103V4.7852C7.01587 4.5662 7.19353 4.38867 7.41269 4.38867Z"
      fill="#1D1D1B"
    />
  </svg>
);
